import { ReactNode } from "react";
import { View } from "@aws-amplify/ui-react";

interface PageContainerProps {
  children: ReactNode;
}

function PageContainer({ children }: PageContainerProps) {
  return (
    <View
      width="100%"
      padding={{ base: "1.5rem", medium: "2rem" }}
      // maxWidth removed as requested
    >
      {children}
    </View>
  );
}

export default PageContainer;
